import {clsx} from 'clsx'
import type React from 'react'

import styles from './Section.module.css'

export type SectionProps = {
  children?: React.ReactNode
  emptyText?: string | React.ReactElement
  sectionHeader: React.ReactElement
  sectionFooter?: React.ReactElement
  hideDivider?: boolean
  id?: string
  className?: string
}

export function Section({children, emptyText, sectionHeader, sectionFooter, hideDivider, id, className}: SectionProps) {
  return (
    <div
      data-testid={id ?? 'sidebar-section'}
      className={clsx(styles.SectionContainer, hideDivider && styles.hideDivider, className)}
    >
      <div className={styles.headerContentWrapper}>
        {sectionHeader}
        {emptyText && (
          <>
            <span className={styles.emptyText}>{emptyText}</span>
            <div className={styles.hiddenChildrenContainer}>{children}</div>
          </>
        )}
      </div>
      {!emptyText && <div className={styles.childrenContainer}>{children}</div>}
      {sectionFooter}
    </div>
  )
}
